export const LOSS_REASONS = [
  { id: "price", label: "Price too high" },
  { id: "timing", label: "Timing not right" },
  { id: "competitor", label: "Chose competitor" },
  { id: "not_qualified", label: "Not qualified" },
  { id: "no_response", label: "No response / unreachable" },
  { id: "other", label: "Other" },
];

export function buildLossExtra1(reasonId, note = "") {
  const label = LOSS_REASONS.find((r) => r.id === reasonId)?.label || reasonId;
  return JSON.stringify({
    lossReason: reasonId,
    lossReasonLabel: label,
    lossNote: String(note || "").trim(),
    lossRecordedAt: new Date().toISOString(),
  });
}

export function parseLossReason(extra1) {
  if (!extra1) return null;
  try {
    const parsed = JSON.parse(extra1);
    if (parsed?.lossReason) return parsed;
  } catch {
    /* plain string legacy */
  }
  return null;
}
